import { render, staticRenderFns } from "./BeCardUnknownEmployee.vue?vue&type=template&id=535ca22c&scoped=true"
import script from "./BeCardUnknownEmployee.vue?vue&type=script&lang=js"
export * from "./BeCardUnknownEmployee.vue?vue&type=script&lang=js"
import style0 from "./BeCardUnknownEmployee.vue?vue&type=style&index=0&id=535ca22c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535ca22c",
  null
  
)

export default component.exports